import {
    ALERT_TYPES_DEVICE_MODEL_REQUEST,
    ALERT_TYPES_DEVICE_MODEL_RESULT,
    ALERT_TYPES_DETAILS_OPEN_MODAL,
    ALERT_TYPES_DETAILS_REQUEST,
    ALERT_TYPES_DETAILS_RESULT,
    ALERT_TYPES_UPDATE_REQUEST,
    ALERT_TYPES_UPDATE_RESULT
} from 'Redux/actionTypes';

export const alertTypesDetailsOpenModal = (open, data) => ({
    type: ALERT_TYPES_DETAILS_OPEN_MODAL,
    payload: { open, data }
})

export const alertTypesDetailsRequest = (id) => ({
    type: ALERT_TYPES_DETAILS_REQUEST,
    payload: { id }
})

export const alertTypesDetailsResult = (data) => ({
    type: ALERT_TYPES_DETAILS_RESULT,
    payload: { data }
})

export const alertTypesDeviceModelRequest = (id, name) => ({
    type: ALERT_TYPES_DEVICE_MODEL_REQUEST,
    payload: { id, name }
})

export const alertTypesDeviceModelResult = (data) => ({
    type: ALERT_TYPES_DEVICE_MODEL_RESULT,
    payload: { data }
})

export const alertTypesUpdateRequest = (data) => ({
    type: ALERT_TYPES_UPDATE_REQUEST,
    payload: data
})

export const alertTypesUpdateResult = (data) => ({
    type: ALERT_TYPES_UPDATE_RESULT,
    payload: data
})